import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.from.js";
import _slicedToArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es7.array.flat-map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es7.object.entries.js";
// See ./README.md for help on the structure of questionType modules.
import sortBy from 'lodash/sortBy';
import { store } from "../../../store";
import { arrayify } from "../../../functions/utils";
import Logger from 'js-logger';
import { FIB } from "../../../config/constants";
var TX_ASK_QUESTION = FIB.TX_ASK_QUESTION;
import SummaryBuilder from "./_summaryBuilder"; // Yes, this is ugly, but again, the string keyed sections will become legitimate QUESTION_TYPES in time.

import other from "./other";
import contextSensitive from "./contextSensitive";
import productRelated from "./productRelated";
import drilldown from "./drilldown";
import drilldownPlus from "./drilldownPlus";
import menuInsight from "./menuInsight";
import indicators from "./indicators";
import nps from "./nps";
import staff from "./staff";
import comments from "./comments";
import demographics from "./demographics";
var questionTypes = [other, productRelated, contextSensitive, drilldown, drilldownPlus, menuInsight, indicators, nps, staff, comments, demographics];
/**
 * Resolve from a section/question combination to the relevant module.
 *   This attempts to abstract over the complexity of sections and questions, however,
 * this function will get a lot simpler and remove the need for section entirely when
 * all sections become question types!
 *
 * @param {Object} context context
 * @param {Object} context.section section
 * @param {Object} context.question question
 *
 * @returns {Object} Module or null if not supported
 */

function getQuestionType(context) {
  var key = context.section.name == 'questions' ? context.question.questionType : context.section.name;
  return questionTypes.find(function (qt) {
    return qt.type === key;
  }) || null;
}
/**
 * Filters questions down to question responses left for a specific section
 *
 * @param {String} name Section name
 * @returns {Array} Array of responses
 */


function getSection(name) {
  return store.getters['answers/questions'].filter(function (q) {
    return q.meta.section.name == name;
  });
}
/**
 * Extracts survey questions along with all responses for that survey question.
 *
 * @returns {Array} An element for each survey question answered, along with all responses for that question.
 */


function groupedQuestions() {
  var mapped = getSection('questions').reduce(function (previous, current) {
    previous[current.meta.question.id] = previous[current.meta.question.id] || {
      question: current.meta.question,
      answers: []
    };
    previous[current.meta.question.id].answers.push(current);
    return previous;
  }, {});
  return Object.values(mapped);
}
/**
 * Generic-level question filters:
 * The following functions have shared signature, and implement generic (/common) filtering.
 */


var genericQuestionFilters = {
  // Ask questions where we know the question type.
  unsupportedQuestionType: function unsupportedQuestionType(_ref) {
    var questionType = _ref.questionType;
    return !!questionType;
  },
  // Ask questions which either don't require a transaction, or do and we have one.
  requiresTransaction: function requiresTransaction(_ref2) {
    var questionType = _ref2.questionType;
    return !questionType.requiresTransaction || store.getters['checkIn/hasTransaction'];
  },
  // Ask questions within dateRange* boundaries.
  visitDatetime: function visitDatetime(_ref3) {
    var question = _ref3.question;
    var visitDatetime = store.getters['questions/getVisitDatetime'];
    return visitDatetime && (!question.dateRangeFrom || visitDatetime.isSameOrAfter(question.dateRangeFrom, 'days')) && (!question.dateRangeTo || visitDatetime.isSameOrBefore(question.dateRangeTo, 'days'));
  },
  // Ask questions based on the txAskQuestion flag.
  txAskQuestion: function txAskQuestion(_ref4) {
    var question = _ref4.question;
    // We have a transaction if there is check information available
    var hasTransaction = store.getters['checkIn/hasTransaction'];
    var validTxAskQuestionOptions = [TX_ASK_QUESTION.TX_ASK_QUESTION_ALWAYS, hasTransaction ? TX_ASK_QUESTION.TX_ASK_QUESTION_WHEN_TRANSACTION : TX_ASK_QUESTION.TX_ASK_QUESTION_WHEN_NO_TRANSACTION];
    return validTxAskQuestionOptions.includes(question.txAskQuestion);
  }
};
/**
 * Perform question-specific sorting.
 */

export var getSortedQuestions = function getSortedQuestions(questions) {
  // Sort questions - descending weight, else randomly (cf FIB-4423)
  return sortBy(questions, [function (q) {
    return -q.weight;
  }, function () {
    return Math.random();
  }]);
};
/**
 * Determine the questions which could be asked based on the answer to the triggering question.
 */

var getTriggeredFollowUpIds = function getTriggeredFollowUpIds(triggerableFollowUps, answer) {
  var _questionType$getTrig;

  if (!answer) {
    return [];
  }

  var question = answer.meta.question;

  if (!question) {
    return [];
  }

  var questionType = questionTypes.find(function (qt) {
    return qt.type === question.questionType;
  }); // Trigger answers are always returned in triggerableFollowUps as object keys - hence strings,
  // so for sake of comparison we should ensure we refer to the answers here as strings too.

  var triggerAnswers = (((_questionType$getTrig = questionType.getTriggerAnswers) === null || _questionType$getTrig === void 0 ? void 0 : _questionType$getTrig.call(questionType, answer)) || []).map(function (a) {
    return a === null || a === void 0 ? void 0 : a.toString();
  }); // At this point, triggerableFollowUps will take the following form:
  // {
  //   "6": {
  //     "0": 15443
  //   },
  //   "5": {
  //     "0": 15669
  //   },
  //   "3": {
  //     "0": 15670,
  //     "1": 15671
  //   }
  // }
  // If the answers for this question are ["3", "5"], we want to return the list of question ids to
  // pose for those answers - in this case it's [15670, 15671] from "3" & [15669] from "5".

  var triggeredQuestionIds = Object.keys(triggerableFollowUps).filter(function (triggerAnswer) {
    return triggerAnswers.includes(triggerAnswer);
  }).flatMap(function (triggerAnswer) {
    return Object.values(triggerableFollowUps[triggerAnswer] || {});
  }); // Dedupe question ids, this may occur for e.g. multi-select answers.

  return _toConsumableArray(new Set(triggeredQuestionIds));
};

export var getTriggeredFollowUpQuestions = function getTriggeredFollowUpQuestions(questionsDetail, questionId, answer) {
  var _Object$values, _Object$values$filter;

  // For the given questionId, determine the triggered follow-ups. The format is an array of:
  // questionId -> map of trigger answer to 'array' of question ids which are triggered.
  var followUpTriggers = questionsDetail.followUpTriggers || [];
  var triggerableFollowUps = followUpTriggers[questionId] || {};
  Logger.debug('Triggerable follow-ups for', questionId, triggerableFollowUps);
  var triggeredFollowUpIds = getTriggeredFollowUpIds(triggerableFollowUps, answer); // We add a field to indicate that this is a triggered follow-up question as there's nothing sent
  // from the API to indicate that. Note that the API *does* send a field confusingly called
  // `followUpQuestion` which is completely unrelated :(

  return ((_Object$values = Object.values(questionsDetail.followUpQuestions)) === null || _Object$values === void 0 ? void 0 : (_Object$values$filter = _Object$values.filter(function (q) {
    return triggeredFollowUpIds.includes(q.id);
  })) === null || _Object$values$filter === void 0 ? void 0 : _Object$values$filter.map(function (q) {
    return _objectSpread(_objectSpread({}, q), {}, {
      isTriggeredFollowUpQuestion: true
    });
  })) || [];
};
/**
 * Insert non-linked follow-up questions into the correct positions within the currently scheduled questions.
 * @param {Array} questions
 * @param {Number} currentQuestionIndex
 * @param {Array} followUpQuestions
 * @returns Array
 */

var insertNonLinkedFollowUpQuestions = function insertNonLinkedFollowUpQuestions(questions, currentQuestionIndex, followUpQuestions) {
  // Non-linked follow-up questions are placed immediately and contiguously after the current
  // question, ordered correctly.
  followUpQuestions = followUpQuestions.filter(function (q) {
    return !q.linkedQuestion;
  });
  questions.splice.apply(questions, [currentQuestionIndex + 1, 0].concat(_toConsumableArray(getSortedQuestions(followUpQuestions))));
  return questions;
};
/**
 * Insert linked follow-up questions into the correct positions within the currently scheduled questions.
 * @param {Array} questions
 * @param {Number} currentQuestionIndex
 * @param {Array} followUpQuestions
 * @returns Array
 */


var insertLinkedFollowUpQuestions = function insertLinkedFollowUpQuestions(questions, currentQuestionIndex, followUpQuestions) {
  followUpQuestions = followUpQuestions.filter(function (q) {
    return q.linkedQuestion;
  });

  var _iterator = _createForOfIteratorHelper(followUpQuestions),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var linkedFollowUpQuestion = _step.value;
      // Determine which question to insert this question before. We always need to put it somewhere,
      // that's why we default to the end of the survey.
      var linkedFollowUpQuestionIndex = questions.length; // Regardless of weight (even if they have a higher weighting than the current question or those
      // before it) - any linked question always comes after the current one.

      for (var i = currentQuestionIndex + 1; i < questions.length; i++) {
        var question = questions[i]; // Ignore non-linked follow-up questions, as we never want to insert this question before
        // one (that would lead to an unrelated question being present between an initiating
        // question and its follow-ups!) or in the middle of some (as non-linked follow-ups should
        // be contiguous).

        if (question && (!question.isTriggeredFollowUpQuestion || question.linkedQuestion)) {
          // We want to insert the linked question before the first one of equal or lower weighting.
          if (linkedFollowUpQuestion.weight >= question.weight) {
            linkedFollowUpQuestionIndex = i;
            break;
          }
        }
      }

      questions.splice(linkedFollowUpQuestionIndex, 0, linkedFollowUpQuestion);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return questions;
};
/**
 * Insert follow-up questions into the correct positions within the currently scheduled questions.
 * @param {Array} questions
 * @param {Number} currentQuestionIndex
 * @param {Array} followUpQuestions
 * @returns Array
 */


export var insertFollowUpQuestions = function insertFollowUpQuestions(questions, currentQuestionIndex, followUpQuestions) {
  // Take a shallow copy to ensure we're not modifying the passed array.
  questions = _toConsumableArray(questions);
  questions = insertNonLinkedFollowUpQuestions(questions, currentQuestionIndex, followUpQuestions);
  questions = insertLinkedFollowUpQuestions(questions, currentQuestionIndex, followUpQuestions);
  return questions;
};
var QuestionTypes = {
  /**
   * Documents the sections which are dependent on other section being completed
   * @param {String} sectionName
   * @returns {Array} Dependencies for the given section.
   */
  dependencyMap: function dependencyMap() {
    var commonDependencies = ['indicators', 'nps'];
    return {
      questions: commonDependencies,
      staff: commonDependencies
    };
  },

  /**
   * Determines if a specific question should be posed.
   *
   * @param {Object} context context
   * @param {Object} context.section section
   * @param {Object} context.survey survey
   * @param {Object} context.question question
   * @param {Object} context.selection selection
   *
   * @returns {Array} Array of questions
   */
  select: function () {
    var _select = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
      var _context$knownPassing, _context$question;

      var questionType, pass, _i, _Object$entries, _Object$entries$_i, name, filter, _pass;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              questionType = getQuestionType(context);

              if (questionType) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              if (!questionType.selectBasedOnCounts) {
                _context.next = 10;
                break;
              }

              _context.next = 6;
              return questionType.selectBasedOnCounts(context);

            case 6:
              pass = _context.sent;
              Logger.debug("Question-type's count-based filter: ".concat(pass ? 'pass' : 'fail'));

              if (pass) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", false);

            case 10:
              if (!((_context$knownPassing = context.knownPassingQuestionIds) !== null && _context$knownPassing !== void 0 && _context$knownPassing.includes(context === null || context === void 0 ? void 0 : (_context$question = context.question) === null || _context$question === void 0 ? void 0 : _context$question.id))) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", true);

            case 12:
              if (!context.question) {
                _context.next = 24;
                break;
              }

              Logger.debug("Applying generic filters");
              _i = 0, _Object$entries = Object.entries(genericQuestionFilters);

            case 15:
              if (!(_i < _Object$entries.length)) {
                _context.next = 24;
                break;
              }

              _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), name = _Object$entries$_i[0], filter = _Object$entries$_i[1];
              _pass = filter(_objectSpread(_objectSpread({}, context), {}, {
                questionType: questionType
              }));
              Logger.debug("Generic filter [".concat(name, "]: ").concat(_pass ? 'pass' : 'fail'));

              if (_pass) {
                _context.next = 21;
                break;
              }

              return _context.abrupt("return", false);

            case 21:
              _i++;
              _context.next = 15;
              break;

            case 24:
              // If we don't have a generic reason or based on counts for rejecting the question, defer to the
              // specific question type's select().
              Logger.debug("Question type's non count-based filter");
              _context.next = 27;
              return questionType.select(context);

            case 27:
              return _context.abrupt("return", _context.sent);

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function select(_x) {
      return _select.apply(this, arguments);
    }

    return select;
  }(),

  /**
   * The 'question selection algorithm'.
   *
   * Selects questions to pose from all possible. This is async to handle the (rare) case
   * of api calls being necessary.
   *
   * @param {Object} context context
   * @param {Object} context.section section
   * @param {Object} context.survey survey
   * @param {Object} context.questions questions
   * @param {Array} context.existingQuestions Previously existing questions to append to. Defaults to [].
   * @param {Array} context.knownPassingQuestionIds Known passing questions selected by this function. Defaults to [].
   *
   * @returns {Array} Array of questions
   */
  selectQuestions: function () {
    var _selectQuestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
      var _iterator2, _step2, question, pass;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // define some methods along with the question selection to help implement most common limits on question selections.
              context.selection = {
                questions: context.existingQuestions || [],
                count: function count() {
                  return this.questions.length;
                },
                countBy: function countBy(by) {
                  return this.questions.filter(by).length;
                },
                countByType: function countByType(types) {
                  return this.countBy(function (q) {
                    return arrayify(types).includes(q.questionType);
                  });
                },
                countByTypeAndTopLevelRating: function countByTypeAndTopLevelRating(types, topLevelRating) {
                  return this.countBy(function (q) {
                    return arrayify(types).includes(q.questionType) && q.topLevelRating == topLevelRating;
                  });
                }
              }; // Iterate questions in decreasing weight, and rather than checking if all can be selected, then filtering
              // down to the maximum, it's more performant to only check up to the maximum, to prevent unnecessary api calls
              // etc for certain question types

              _iterator2 = _createForOfIteratorHelper(context.questions);
              _context2.prev = 2;

              _iterator2.s();

            case 4:
              if ((_step2 = _iterator2.n()).done) {
                _context2.next = 17;
                break;
              }

              question = _step2.value;
              context.question = question;
              Logger.debug("Question ".concat(context.question.id, ": Under consideration..")); // Don't ask more questions than the maximumQuestionCount

              if (!(context.selection.count() >= context.survey.maximumQuestionCount)) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("continue", 15);

            case 10:
              _context2.next = 12;
              return QuestionTypes.select(context);

            case 12:
              pass = _context2.sent;
              Logger.debug("Question ".concat(context.question.id, ": ").concat(pass ? 'pass' : 'fail'));

              if (pass) {
                context.selection.questions.push(question);
              }

            case 15:
              _context2.next = 4;
              break;

            case 17:
              _context2.next = 22;
              break;

            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](2);

              _iterator2.e(_context2.t0);

            case 22:
              _context2.prev = 22;

              _iterator2.f();

              return _context2.finish(22);

            case 25:
              return _context2.abrupt("return", context.selection.questions);

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 19, 22, 25]]);
    }));

    function selectQuestions(_x2) {
      return _selectQuestions.apply(this, arguments);
    }

    return selectQuestions;
  }(),

  /**
   * Render a given question/section as a Screen model
   *
   * @param {Object} context
   * @param {Object} context.section section
   * @param {Object} context.survey survey
   * @param {Object} context.question question
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context) {
      var questionType;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              questionType = getQuestionType(context);

              if (!questionType) {
                _context3.next = 7;
                break;
              }

              _context3.next = 4;
              return questionType.render(context);

            case 4:
              _context3.t0 = _context3.sent;
              _context3.next = 8;
              break;

            case 7:
              _context3.t0 = null;

            case 8:
              return _context3.abrupt("return", _context3.t0);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function render(_x3) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Populate answers from each question type.
   */
  parseAnswers: function parseAnswers() {
    var answers = [];

    var parseAnswer = function parseAnswer(context, questionType) {
      // let the questionType parse the content from the context
      var answer = questionType.parseAnswer(context); // then if something was returned, merge the context into the answer and store it

      answer && answers.push(_objectSpread(_objectSpread({}, context), answer));
    }; // Run through each question type


    questionTypes.forEach(function (questionType) {
      var type = questionType.type; // this is crap - however, as stated elsewhere - sections will be converted to question types later anyhow so this will all be simpler then.

      var isSection = isNaN(type); // section always lives in the context

      var section = store.getters['questions/getSection'](isSection ? type : 'questions'); // if the section doesn't exist, it's been turned off, so we'd get no answers from it anyhow

      if (!section) {
        return;
      }

      var context = {
        section: section,
        type: isSection ? type : parseInt(type)
      }; // sections only have 1 answer, survey questions have an answer per instance of a question of that type

      if (isSection) {
        parseAnswer(_objectSpread(_objectSpread({}, context), {}, {
          response: getSection(context.section.name)
        }), questionType);
      } else {
        groupedQuestions().filter(function (question) {
          return question.question.questionType == type;
        }).forEach(function (question) {
          return parseAnswer(_objectSpread(_objectSpread({}, context), {}, {
            question: question.question,
            response: question
          }), questionType);
        });
      }
    });
    return answers;
  },

  /**
   * Build a question summary
   *
   * @param {Object} context Deferred to SummaryBuilder
   * @returns {Array}
   */
  summarise: function summarise(context) {
    var builder = SummaryBuilder(context);

    var _iterator3 = _createForOfIteratorHelper(questionTypes),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var questionType = _step3.value;
        // Determine if the question type exports a summary interface
        var summary = questionType.summary;

        if (!summary) {
          continue;
        } // Set the default weight for the section, so that all items from that question type are weighted equally.


        builder.setWeight(summary.weight); // Build the summary for the section

        summary.build({
          builder: builder
        });
      } // Now every question has had a chance to populate the summary, build the final result!

    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return builder.build();
  }
};
export default QuestionTypes;